export function isNewPokerServerTournament(tournamentId: string): boolean {
    const uuidv4Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    const matchNewPokerServerFormat = tournamentId.match(uuidv4Regex);
    return (matchNewPokerServerFormat !== null);
}



// WEBPACK FOOTER //
// ./src/app/utils/PokPoker.ts